import PasscodeInput from './PasscodeInput';

export default PasscodeInput;